'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { usePixelatedConfig } from "../config/config.client";
import { SmartErrorBoundary } from "../foundation/smarterrorboundary";
import "./googlesearch.css";
/**
 * GoogleSearch — Embed a Google Programmable Search box and results.
 *
 * @param {GoogleSearchType} props - Component properties.
 */
GoogleSearch.propTypes = {
/** no props */
};
export function GoogleSearch(props) {
    const config = usePixelatedConfig();
    const id = config?.integrations?.googleSearch?.id || config?.integrations?.googleSearchConsole?.id;
    useEffect(() => {
        if (!id)
            return;
        const head = document.querySelector("head");
        const script = document.createElement("script");
        script.setAttribute("src", "https://cse.google.com/cse.js?cx=" + id);
        script.setAttribute("async", "true");
        if (head)
            head.appendChild(script);
    }, [id]);
    if (!id) {
        return (_jsx("div", { className: "smart-error-boundary-fallback", children: _jsx("p", { children: "Sorry, something went wrong loading GoogleSearch." }) }));
    }
    return (_jsx(SmartErrorBoundary, { boundaryName: "GoogleSearch", children: _jsx("div", { className: "gcse-search", suppressHydrationWarning: true }) }));
}
